import { useAuthenticatedFetch } from '@/composables/useAuthenticatedFetch'
import { UpdateCartRequestPayload } from '@/models/request/cart/UpdateCartRequestPayload'
import { DeleteCartItemRequestPayload } from '../models/request/cart/DeleteCartItemRequestPayload'

export const shoppingCartRepository = {
  async fetchCart(cartId) {
    return await useAuthenticatedFetch(`/api/cart/${cartId}`)
  },
  async createCart() {
    return await useAuthenticatedFetch('/api/cart', {
      method: 'POST'
    })
  },
  /**
   * @param {cartId} String
   * @param {UpdateCartRequestPayload} payload
   */
  async updateCart({ cartId, payload }) {
    return await useAuthenticatedFetch(`/api/cart/${cartId}/cart-line`, {
      method: 'POST',
      body: payload
    })
  },

  /**
   * 
   * @param {cartId} String
   * @param {DeleteCartItemRequestPayload} payload 
   */
  async deleteCartItem({ cartId, payload }) {
    return await useAuthenticatedFetch(`/api/cart/${cartId}/cart-line`, {
      method: 'DELETE',
      body: payload
    })
  },

  /**
   * @param {cartId} String
   */
  async clearCart(cartId) {
    return await useAuthenticatedFetch(`/api/cart/clear/${cartId}`, {
      method: 'DELETE'
    })
  }
}
